import { Component, OnInit } from '@angular/core';
import { EmergencyService } from 'src/app/core/services/emergency.service';

@Component({
  selector: 'app-emergency-position',
  templateUrl: './emergency-position.component.html',
  styleUrls: ['./emergency-position.component.scss'],
})
export class EmergencyPositionComponent implements OnInit {
  constructor(public emergencyService: EmergencyService) {}

  items: any[] = [];
  circularProgressiveWait: boolean = false;
  errorMessage: string = '';
  installationMap: { [serial: string]: { loading: boolean; data: any; error: string } } = {};

  ngOnInit(): void {
    this.loadData();
  }

  loadData(): void {
    this.circularProgressiveWait = true;
    this.errorMessage = '';
    this.installationMap = {};
    this.emergencyService.getEmergencyPositions().subscribe({
      next: (data) => {
        this.items = data;
        this.circularProgressiveWait = false;
      },
      error: (err) => {
        this.circularProgressiveWait = false;
        this.errorMessage =
          err?.name === 'TimeoutError'
            ? 'O serviço não respondeu no tempo esperado. Tente novamente.'
            : 'Erro ao carregar os dados. Tente novamente.';
      },
    });
  }

  loadInstallation(serial: string): void {
    if (this.installationMap[serial]) return;
    this.installationMap[serial] = { loading: true, data: null, error: '' };
    this.emergencyService.getDeviceInstallation(serial).subscribe({
      next: (data) => {
        const hasData = data && (data.deviceName || data.brand || data.model || data.versaoFirmware);
        this.installationMap[serial] = { loading: false, data: hasData ? data : null, error: '' };
      },
      error: () => {
        this.installationMap[serial] = { loading: false, data: null, error: 'Erro ao carregar instalação.' };
      },
    });
  }

  exportCsv(): void {
    const headers = ['Serial', 'Placa', 'Fornecedor', 'Tipo Evento', 'Latitude', 'Longitude', 'Ignicao', 'Velocidade', 'Data/Hora Evento', 'Ativo', 'Hardware', 'Marca', 'Modelo'];
    const rows = this.items.map(item => [
      item.serial,
      item.placa ?? '-',
      item.fornecedorRastreador,
      item.tipoEvento,
      item.latitude,
      item.longitude,
      item.ignicao,
      item.velocidade,
      item.datahora,
      item.installation?.isActive ? 'Sim' : 'Não',
      item.installation?.deviceName ?? '',
      // item.versaoFirmware ?? '',
      item.installation?.brand ?? '',
      item.installation?.model ?? '',
    ]);
    this.downloadCsv('posicoes-emergencia.csv', headers, rows);
  }

  private downloadCsv(filename: string, headers: string[], rows: any[][]): void {
    const escape = (v: any) => `"${String(v ?? '').replace(/"/g, '""')}"`;
    const csv = [headers.map(escape).join(';'), ...rows.map(r => r.map(escape).join(';'))].join('\n');
    const blob = new Blob(['\uFEFF' + csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
  }
}
